import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_b9tkF471qv36: {
	id: 'prd_b9tkF2DEV2471qv36'
	ident: 'prd_b9tkF471qv36'
	sku: 'simple_premium_12w_13_59_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_5qSl42DEV2VRmbPPS'
			amount: 79
			amount_usd: 13.59
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 13.59
			discount: 65.41
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_QdYGy2DEV2GzFMzsN'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_b9tkF471qv36, SubscriptionProduct>
const prd_b9tkF471qv36 = { ident: 'prd_b9tkF471qv36' } as typeof _prd_b9tkF471qv36

export default prd_b9tkF471qv36
